<cigna-icon
  *ngIf="hasRole === 'bot'"
  type="cigna-tree"
  class="cignatree"
></cigna-icon>

<div
  *ngIf="hasRole === 'agent'"
  [class]="
    agentLogoColor === 'red' ? 'agentLogoWrapper red' : 'agentLogoWrapper green'
  "
>
  <label
    [class]="
      agentLogoColor === 'red'
        ? 'agentCharLogo redChar'
        : 'agentCharLogo greenChar'
    "
    >{{ participantName.substring(0, 1).toLocaleUpperCase() }}</label
  >
</div>
